window.addEventListener('scroll', (e) => {
	isScrolled();
});

function isScrolled() {
	if ( window.scrollY > 5 ) {
		document.querySelector('body').classList.add('is-scrolled')
	} else {
		document.querySelector('body').classList.remove('is-scrolled');
	}
}

export default isScrolled;